import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _class;
import React from 'react';
import intl from '../../utils/intl';
import { BlockContainer } from './index.style';
import SectionTitle from '../_components/SectionTitle';
import ConfigItem from '../_components/ConfigItem';
import withFormOperate from '../_components/withFormOperate';
import { getMemoizedAssets } from './util';
var ListConfig = withFormOperate(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(ListConfig, _React$Component);
  var _super = _createSuper(ListConfig);
  function ListConfig() {
    var _this;
    _classCallCheck(this, ListConfig);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.getList = getMemoizedAssets(_this.props.styleCounts.list, 'list/list-single');
    _this.getListWithAction = getMemoizedAssets(_this.props.styleCounts.list, 'list/list-single_operate');
    _this.getListDouble = getMemoizedAssets(_this.props.styleCounts.list, 'list/list-double');
    _this.getListDoubleAction = getMemoizedAssets(_this.props.styleCounts.list, 'list/list-double_operate');
    return _this;
  }
  _createClass(ListConfig, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        schema = _this$props.schema,
        handleChange = _this$props.handleChange;
      return /*#__PURE__*/React.createElement(BlockContainer, {
        id: "list-config"
      }, /*#__PURE__*/React.createElement(SectionTitle, {
        title: "\u5217\u8868",
        titleTail: "List"
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        cols: 2,
        title: intl.get('hzero.hzeroTheme.page.basicList').d('基础列表'),
        items: this.getList(schema),
        defaultSelected: value,
        onChange: handleChange('style')
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        cols: 2 // title="单行列表+操作"
        ,

        title: intl.get('hzero.hzeroTheme.page.basicListWithAction').d('基础列表+操作') // items={withActions}
        ,

        onChange: handleChange('style'),
        items: this.getListWithAction(schema),
        defaultSelected: value
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        cols: 2 // title="多行列表"
        ,

        title: intl.get('hzero.hzeroTheme.page.verticalList').d('多行列表') // items={multiLine}
        ,

        onChange: handleChange('style'),
        items: this.getListDouble(schema),
        defaultSelected: value
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        cols: 2 // title="多行列表+操作"
        ,

        title: intl.get('hzero.hzeroTheme.page.verticalListWithAction').d('多行列表+操作') // items={multiLine}
        ,

        onChange: handleChange('style'),
        items: this.getListDoubleAction(schema),
        defaultSelected: value
      }));
    }
  }]);
  return ListConfig;
}(React.Component)) || _class;
export { ListConfig as default };